/* Adds "Events & recordings" (Pariyatti Presents + Podcasts) to the header
   autocomplete and to the /search results page. Data: json.prytti.me/search-index.json,
   rebuilt hourly from the Episodes sheet. Each entry: t=title, u=url, k=kind,
   d=date (YYYY-MM-DD or YYYY-MM), s=normalized search text. */
(function () {
  var INDEX_URL = 'https://json.prytti.me/search-index.json';
  var indexPromise = null;

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function loadIndex() {
    if (!indexPromise) {
      indexPromise = fetch(INDEX_URL)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { indexPromise = null; return []; });
    }
    return indexPromise;
  }
  function when(d) {
    var m = /^(\d{4})-(\d{2})/.exec(d || '');
    if (!m) return '';
    var M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return M[parseInt(m[2], 10) - 1] + ' ' + m[1];
  }
  function match(index, term, limit) {
    var tokens = norm(term).split(/[^a-z0-9]+/).filter(Boolean);
    if (!tokens.length) return { total: 0, items: [] };
    var hits = index.filter(function (e) {
      return tokens.every(function (t) { return e.s.indexOf(t) > -1; });
    });
    hits.sort(function (a, b) {
      var at = tokens.every(function (t) { return norm(a.t).indexOf(t) > -1; }) ? 0 : 1;
      var bt = tokens.every(function (t) { return norm(b.t).indexOf(t) > -1; }) ? 0 : 1;
      return at - bt || String(b.d || '').localeCompare(String(a.d || ''));
    });
    return { total: hits.length, items: limit ? hits.slice(0, limit) : hits };
  }

  /* ---------- header autocomplete ---------- */
  function addStyles() {
    if (document.getElementById('piv-event-search-css')) return;
    var st = document.createElement('style');
    st.id = 'piv-event-search-css';
    st.textContent =
      '.piv-events-group{padding:0 0 1rem;margin-bottom:.5rem;border-bottom:.1rem solid rgba(var(--color-base-text),.08)}' +
      '.piv-ev-meta{display:block;font-size:1.2rem;opacity:.7;margin-top:.2rem}' +
      '.piv-events-results{margin:2rem auto;max-width:var(--page-width,120rem);padding:0 1.5rem}' +
      '.piv-events-results ul{list-style:none;margin:1rem 0 0;padding:0}' +
      '.piv-events-results li{padding:.9rem 0;border-bottom:.1rem solid rgba(var(--color-base-text),.1)}' +
      '.piv-events-results h2{color:rgb(var(--color-secondary-heading))}' +
      '.piv-events-results a{color:rgb(var(--color-base-heading));font-weight:500;text-decoration:underline;text-underline-offset:.3rem}' +
      '.piv-events-results a:hover{opacity:.8}' +
      '.piv-events-results .piv-ev-meta{font-size:1.3rem}';
    document.head.appendChild(st);
  }
  function inject(container, term, stillCurrent) {
    if (!container || !term) return Promise.resolve();
    addStyles();
    return loadIndex().then(function (index) {
      // The user may have kept typing (or closed the dropdown) while the index loaded.
      if (stillCurrent && !stillCurrent()) return;
      var res = match(index, term, 6);
      var old = container.querySelector('.piv-events-group');
      if (old) old.remove();
      if (!res.items.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'piv-events-group predictive-search__result-group piv-grp piv-grp--events';
      wrap.dataset.total = res.total;
      var items = res.items.map(function (e, i) {
        var meta = esc(e.k) + (when(e.d) ? ' · ' + esc(when(e.d)) : '');
        return '<li id="predictive-search-option-event-' + (i + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false">' +
          '<a href="' + esc(e.u) + '" class="predictive-search__item link link--text" tabindex="-1">' +
          '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
          '<p class="predictive-search__item-heading h6">' + esc(e.t) + '<span class="piv-ev-meta">' + meta + '</span></p>' +
          '</div></a></li>';
      }).join('');
      var more = res.total > res.items.length
        ? '<li class="predictive-search__list-item"><a class="predictive-search__item link link--text" tabindex="-1" href="/search?q=' +
          encodeURIComponent(term) + '"><div class="predictive-search__item-content predictive-search__item-content--centered"><p class="predictive-search__item-heading h6">See all ' +
          res.total + ' events &amp; podcasts</p></div></a></li>'
        : '';
      wrap.innerHTML = '<div><h2 id="predictive-search-events" class="predictive-search__heading">Events &amp; Podcasts</h2>' +
        '<ul class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-events">' + items + more + '</ul></div>';
      container.insertBefore(wrap, container.firstChild);
    });
  }

  /* ---------- /search results page ---------- */
  function resultsPage() {
    var q = new URLSearchParams(location.search).get('q');
    var anchor = document.getElementById('ProductGridContainer');
    if (!q || !anchor) return;
    addStyles();
    loadIndex().then(function (index) {
      var res = match(index, q, 0);
      if (!res.items.length) return;
      var box = document.createElement('div');
      box.className = 'piv-events-results';
      var shown = res.items.slice(0, 40);
      box.innerHTML = '<h2 class="h4">Events &amp; Podcasts (' + res.total + ')</h2><ul>' +
        shown.map(function (e) {
          return '<li><a href="' + esc(e.u) + '">' + esc(e.t) + '</a><span class="piv-ev-meta">' + esc(e.k) +
            (when(e.d) ? ' · ' + esc(when(e.d)) : '') + '</span></li>';
        }).join('') + '</ul>' +
        (res.total > shown.length ? '<p class="piv-ev-meta">Showing the first ' + shown.length + '. Add more words to narrow the list.</p>' : '');
      anchor.parentNode.insertBefore(box, anchor);
    });
  }

  window.pivEventSearch = { inject: inject, match: match, loadIndex: loadIndex };
  if (/^\/search\/?$/.test(location.pathname)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resultsPage);
    else resultsPage();
  }
})();
